import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Link } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/footer";
import "../notes/third.css";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);

const projectCost = 500;

function createData(code, name, cost, buy) {
  return { code, name, cost, buy };
}

const fifthSemProjects = [
  createData("501", "Retail Billing", projectCost, true),
  createData("504", "Ticket booking", projectCost, true),
  createData("502", "Music Store Billing", projectCost, true),
  createData("503", "Supermarket Billing", projectCost, true),

  createData("504", "Car rental", projectCost, true),
  // createData("506", "name 1", projectCost, false),
  // createData("507", "name 2", projectCost, false),
  // createData("508", "name 3", projectCost, false),
  // createData("509", "name 4", projectCost, false),
  // createData("510", "name 1", projectCost, false)
  // createData("511", "name 2", projectCost, false),
  // createData("512", "name 3", projectCost, false),
  // createData("513", "name 4", projectCost, false),
  // createData("514", "name 1", projectCost, false),
  // createData("515", "name 2", projectCost, false)
];

const sixthSemProjects = [
  createData("601", "Space Drift", 600, true),
  createData("602", "Shadows of the day", 600, true),
  createData("603", "Aeroplane takeoff", 600, true),
  createData("604", "Ping Pong game", 550, true),
  createData(
    "605",
    "Evolution of cubes into various geometrical shapes",
    projectCost,
    true
  ),
  createData("606", "3D Room", 500, true)
];

const seventhSemProjects = [
  createData("701", "Digital music streaming", 700, true),
  createData("702", "Blogging Site (using React)", 700, true),
  createData("703", "Car Rental", projectCost, true),
  // createData("704", "name 4", projectCost, false),
  // createData("705", "name 5", projectCost, false)
];

const ProjectLanding = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <Grid container justify={"center"} id="topgrid">
        <Grid item xs={12} md={12} sm={12}>
          <Paper className={classes.paper} style={{ color: "black" }}>
            <h1 id="desc" style={{ textTransform: "uppercase" }}>
              Buy Projects
            </h1>

            <Divider />
            <br />

            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                  5Th Sem DBMS Projects
                </Typography>

      
              </ExpansionPanelSummary>
              Click 'buy' twice if not opening
              <ExpansionPanelDetails>
                {/* {fifthSemProjects.map(p => (
                    <p>
                      Code: {p.code} Name : {p.name} Cost: {p.cost} Available:
                      {p.available ? "Yes" : "No"}
                    </p>
                  ))} */}

                <TableContainer component={Paper} style={{ width: "100%" }}>
                  <Table
                    className={classes.table}
                    aria-label="customized table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Project Code</StyledTableCell>
                        <StyledTableCell align="right">Name</StyledTableCell>
                        <StyledTableCell align="right">Cost</StyledTableCell>

                        <StyledTableCell align="right">Buy</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {fifthSemProjects.map(row => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell component="th" scope="row">
                            {row.code}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.cost}
                          </StyledTableCell>

                          <StyledTableCell align="right">
                            {row.buy ? (
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "green",
                                  color: "white"
                                }}
                        
                              >
                                <a
                                  href="https://docs.google.com/forms/d/e/1FAIpQLSekxtuzsN6XAe5xIYEavhmu16guz0_Zon5Vgi05ya4C4TvyDw/viewform?usp=sf_link"
                                  style={{
                                    textDecoration: "none",
                                    color: "white"
                                  }}
                                >
                                  Buy
                                </a>
                              </Button>
                            ) : (
                              <Button variant="contained" disabled>
                                Sold
                              </Button>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className={classes.heading}>
                  6Th Sem Computer Graphics Projects
                </Typography>
              </ExpansionPanelSummary>
              Click 'buy' twice if not opening
              <ExpansionPanelDetails>
                <TableContainer component={Paper}>
                  <Table
                    className={classes.table}
                    aria-label="customized table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Project Code</StyledTableCell>
                        <StyledTableCell align="right">Name</StyledTableCell>
                        <StyledTableCell align="right">Cost</StyledTableCell>

                        <StyledTableCell align="right">Buy</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sixthSemProjects.map(row => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell component="th" scope="row">
                            {row.code}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.cost}
                          </StyledTableCell>

                          <StyledTableCell align="right">
                            {row.buy ? (
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "green",
                                  color: "white"
                                }}
          
                              >
                                <a
                                  href="https://docs.google.com/forms/d/e/1FAIpQLSekxtuzsN6XAe5xIYEavhmu16guz0_Zon5Vgi05ya4C4TvyDw/viewform?usp=sf_link"
                                  style={{
                                    textDecoration: "none",
                                    color: "white"
                                  }}
                                >
                                  Buy
                                </a>
                              </Button>
                            ) : (
                              <Button variant="contained" disabled>
                                Sold
                              </Button>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography className={classes.heading}>
                  7Th Sem WEB Projects
                </Typography>
              </ExpansionPanelSummary>
              Click 'buy' twice if not opening
              <ExpansionPanelDetails>
                <TableContainer component={Paper}>
                  <Table
                    className={classes.table}
                    aria-label="customized table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Project Code</StyledTableCell>
                        <StyledTableCell align="right">Name</StyledTableCell>
                        <StyledTableCell align="right">Cost</StyledTableCell>

                        <StyledTableCell align="right">Buy</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {seventhSemProjects.map(row => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell component="th" scope="row">
                            {row.code}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.cost}
                          </StyledTableCell>

                          <StyledTableCell align="right">
                            {row.buy ? (
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "green",
                                  color: "white"
                                }}
              
                              >
                                <a
                                  href="https://docs.google.com/forms/d/e/1FAIpQLSekxtuzsN6XAe5xIYEavhmu16guz0_Zon5Vgi05ya4C4TvyDw/viewform?usp=sf_link"
                                  style={{
                                    textDecoration: "none",
                                    color: "white"
                                  }}
                                >
                                  Buy
                                </a>
                              </Button>
                            ) : (
                              <Button variant="contained" disabled>
                                Sold
                              </Button>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <Divider />
            <h2 style={{ textTransform: "uppercase" }}>
              Contact for more details
            </h2>
            <Divider />
            <p style={{ fontSize: "20px" }}>
              Phone : +91 9591379239 (whatsApp Available) <br />
              Email : viewnotes19@gmail.com
            </p>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
};

export default ProjectLanding;
